import React, { Component } from 'react'
import ErrorBoundary from '@argos/error-boundary'

import Spark from '../../components/Icons/Spark'
import { pushEventThenTrack } from '../../helpers/trackingHelper'

import styles from './AskTrevor.scss'

class AskTrevorCTAButton extends Component {
  constructor(props) {
    super(props)
    this.state = { animate: true }
  }

  componentDidMount() {
    // Only animate server-side
    this.setState({ animate: false })

    if (typeof window.digitalData !== 'undefined' && !!window.digitalData.track) {
      // Trevor loaded event
      pushEventThenTrack({
        eventInfo: {
          eventAction: 'trevor loaded',
          eventName: 'Trevor interaction - loaded',
        },
      })

      // Trevor impression
      pushEventThenTrack({
        eventInfo: {
          eventAction: 'trevor impression',
          eventName: 'Trevor interaction - impression',
        },
      })
    }
  }

  handleAskTrevorCTAClick = () => {
    // Trevor click event
    pushEventThenTrack({
      eventInfo: {
        eventAction: 'trevor icon clicked',
        eventName: 'Trevor interaction',
      },
    })
  }

  render() {
    const { animate } = this.state

    return (
      <ErrorBoundary>
        <button
          className={`${styles.buttonTrevorCTA} ${animate ? styles.bounceAnimation : ''}`}
          data-test='ask-trevor-button'
          aria-label='Open Ask Trevor'
          onClick={() => {
            window.postMessage('open-trevor-drawer')
            this.handleAskTrevorCTAClick()
          }}>
          <span className={styles.buttonTrevorIcon}>
            <Spark />
          </span>
          <span className={styles.buttonTrevorLabel}>Ask Trevor</span>
          <span className={styles.buttonTrevorImage} aria-hidden='true' />
          <div className={styles.buttonTrevorMobileContainer}>
            <span className={styles.buttonTrevorMobileIcon}>
              <Spark gradientFill={true} />
            </span>
            <span className={styles.buttonTrevorMobileImage} aria-hidden='true' />
          </div>
        </button>
      </ErrorBoundary>
    )
  }
}

export default AskTrevorCTAButton
